export const textSelectionEventsCleanup = () => {
    document.querySelectorAll('.TableCells').forEach(item => {
        document.removeEventListener('mousedown', handleMouseDownEventListenr);
    })
    document.querySelectorAll('.RowCells').forEach(item => {
        document.removeEventListener('mousedown', handleMouseDownEventListenr);
    })
}

const handleMouseDownEventListenr = (event: any) => {
    if ((event.which && event.which === 3) || (event.button && event.button === 2)) {
        event.stopPropagation();
    }
}

export const clearTextSelections = ()=> {
    if (window?.getSelection) {
      if (window?.getSelection()?.empty) {
        window?.getSelection()?.empty();
      } else if (window?.getSelection()?.removeAllRanges && window?.getSelection()?.rangeCount! > 0 && window?.getSelection()?.getRangeAt(0)?.getClientRects()?.length! > 0) {
        window?.getSelection()?.removeAllRanges();
      }
    } else if (document['selection'] && document['selection'].empty) {
      try {
        document['selection'].empty();
      } catch (error) {//ignore IE bug
      }
    }
  }

export const handleDataTableTextSelection = () => {
    setTimeout(() => {
        document.querySelectorAll('.TableCells').forEach(item => {
            if (item && item.addEventListener) {
                item.addEventListener('mousedown', handleMouseDownEventListenr)
            }
        })
        document.querySelectorAll('.RowCells').forEach(item => {
            if (item && item.addEventListener) {
                item.addEventListener('mousedown', handleMouseDownEventListenr)
            }
        })
    }, 200);
}
